import { styled } from '@material-ui/core/styles';
import { ICustomTheme } from 'interfaces';

export const StyledContainer = styled('div')(
  ({ theme }: { theme: ICustomTheme }) => ({
    display: 'flex',
    height: '100%',
    flexWrap: 'wrap',
    gap: theme.spacing(2),
    padding: theme.spacing(1),
  }),
);
